import { ToastNotificationCombinedProps } from './types';

const usePresenter = (props: ToastNotificationCombinedProps): ToastNotificationCombinedProps => {
  return props;
};

export default usePresenter;
